import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Select,
  Checkbox,
  Button,
  Grid,
  Box,
  Text,
  Flex,
  useToast,
  Image,
} from "@chakra-ui/react";
import TimeRangeWidget from "../TimeRangeWidget";
import { format } from "date-fns";
import { th } from "date-fns/locale/th";
import axios from "axios";
import { useAuth } from "../../auth/AuthProvider";
import moment from "moment";
import { server } from "../../util/connect";

const PatientRecordModal = ({
  refreshTable,
  curdate,
  recordData,
  isOpen,
  onClose,
}) => {
  const [sTime, setStartTime] = useState("");
  const [eTime, setEndTime] = useState("");
  const [aditionalStartTime, setAditionalStartTime] = useState("");
  const [aditionalEndTime, setAditionalEndTime] = useState("");

  const [record, setRecord] = useState();
  const { user } = useAuth();
  const toast = useToast();

  const imageSet = [
    "lingo_exited.gif",
    "lingo_fighting.gif",
    "lingo_happy.gif",
  ];

  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * imageSet.length);
    return `/images/${imageSet[randomIndex]}`;
  };

  useEffect(() => {
    if (recordData) {
      //console.log("test")
      setRecord({ ...recordData });
    }
  }, [recordData]);

  const numbers = Array.from({ length: 100 }, (_, index) => index);

  const handleSaveRecord = () => {
    const startTime = moment(sTime, "HH:mm");
    const endTime = moment(eTime, "HH:mm");
    const diffInMinute = endTime.diff(startTime, "minutes");

    const astartTime = moment(aditionalStartTime, "HH:mm");
    const aendTime = moment(aditionalEndTime, "HH:mm");
    const additionalDiffInMinute = aendTime.diff(astartTime, "minutes");

    if ((sTime && eTime && diffInMinute && diffInMinute > 0) || (!sTime && !eTime)) {
      if (record.has_additional_period && (aditionalStartTime && aditionalEndTime && additionalDiffInMinute && additionalDiffInMinute > 0)) {
        saveRecord(record);
        onClose();
      }
      else if (record.has_additional_period) {
        toast({
          title: "เวลาออกชดไม่ถูกต้อง",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
      else {
        saveRecord(record);
        onClose();
      }
    } else {
      toast({
        title: "เวลาไม่ถูกต้อง",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const getImage = () => {
    const randomImage = getRandomImage();
    return <Image src={randomImage} alt="mood" loop={true} />;
  };

  const saveRecord = (r) => {
    //axios.defaults.withCredentials = true;
    axios
      .post(`${server}/daily_record/save_record`, {
        record_id: r.id,
        record_date: curdate,
        old_o_case: r.old_o_case,
        new_o_case: r.new_o_case,
        old_r_case: r.old_r_case,
        new_r_case: r.new_r_case,
        lab_num: r.lab_num,
        xray_num: r.xray_num,
        ekg_num: r.ekg_num,
        abi_num: r.abi_num,
        obesity_num: r.obesity_num,
        treatment_num: r.treatment_num,
        refer_num: r.refer_num,
        vacc_flu_num: r.vacc_flu_num,
        vacc_ipd_num: r.vacc_ipd_num,
        vacc_dengue_num: r.vacc_dengue_num,
        vacc_zoster_num: r.vacc_zoster_num,

        vacc_rsv_num: r.vacc_rsv_num,
        ct_num: r.ct_num,
        pft_num: r.pft_num,
        blood_transfusion_num: r.blood_transfusion_num,
        or_num: r.or_num,
        chemo_num: r.chemo_num,
        blood_letting_num: r.blood_letting_num,
        lung_tap_num: r.lung_tap_num,
        bone_marrow_tap_num: r.bone_marrow_tap_num,

        admit_o_case: r.admit_o_case,
        admit_r_case: r.admit_r_case,
        check_up: r.check_up,
        doctor_id: r.did ?? r.doctor_id,
        staff_id: user.id,
        department_id: user.department_id,
        is_skipted: r.is_skipted ?? 0,
        start_diag_time: sTime,
        end_diag_time: eTime,
        has_additional_period: r.has_additional_period ?? 0,
        additional_start_diag_time: aditionalStartTime,
        additional_end_diag_time: aditionalEndTime,
      })
      .then(function (response) {
        //console.log(JSON.stringify(response))
        //alert(response.data.status)
        if (response.data.status == "success") {
          refreshTable();

          toast({
            position: "bottom-center",
            duration: 2000, // 3 seconds
            isClosable: true,
            render: () => (
              <Flex p={0}>
                <Box p={0} boxSize={"50px"}>
                  {getImage()}
                </Box>
                <Flex p={0} justify={"center"} align={"center"}>
                  <Text p={2} borderRadius={10} bgColor={"green"} color="white">
                    อัพเดทข้อมูลสำเร็จ
                  </Text>
                </Flex>
              </Flex>
            ),
          });
        } else {
          toast({
            title: "อัพเดทข้อมูลไม่สำเร็จ",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      })
      .catch(function (error) {
        toast({
          title: "อัพเดทข้อมูลไม่สำเร็จ",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  const startTime = (time) => {
    setStartTime(time);
  };

  const endTime = (time) => {
    setEndTime(time);
  };

  const handleAdditionStartTime = (time) => {
    setAditionalStartTime(time);
  };

  const handleAdditionEndTime = (time) => {
    setAditionalEndTime(time);
  };

  const handleCaseChange = (type, value) => {
    record[type] = value;
    setRecord({ ...record });
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            บันทึกจำนวนคนไข้ (
            {record && record.doctor_name ? record.doctor_name : ""})
            <Text fontSize={14} color="gray">
              {curdate ? format(curdate, "EEEE dd MMMM yyyy", { locale: th }) : ""}
            </Text>
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody bgColor="gray.50" px={{ base: 2, md: 4 }}>
            <Flex
              align={"center"}
              direction={"column"}
              pt={2}
              pb={2}
              bgColor={"blue.50"}
              borderRadius={5}
            >
              {record && record.start_time && record.end_time && (
                <Text mb={1}>
                  เวลาตรวจ{" "}
                  {`${record?.start_time
                    ? moment(record?.start_time, "HH:mm").format("HH:mm")
                    : ""
                    } - ${record?.end_time
                      ? moment(record?.end_time, "HH:mm").format("HH:mm")
                      : ""
                    }`}
                </Text>
              )}
              {sTime && eTime ? (
                <Text mb={3}>เวลาตรวจจริง ({`${sTime} - ${eTime}`})</Text>
              ) : (
                <Text>กรุณาระบุเวลาตรวจจริง</Text>
              )}
              <TimeRangeWidget
                resetTime={record?.is_skipted}
                sHour={
                  record && record.start_diag_time
                    ? `${moment(record?.start_diag_time, "HH:mm").format("HH")}`
                    : ""
                }
                sMinute={
                  record && record.start_diag_time
                    ? `${moment(record?.start_diag_time, "HH:mm").format("mm")}`
                    : ""
                }
                eHour={
                  record && record.end_diag_time
                    ? `${moment(record?.end_diag_time, "HH:mm").format("HH")}`
                    : ""
                }
                eMinute={
                  record && record.end_diag_time
                    ? `${moment(record?.end_diag_time, "HH:mm").format("mm")}`
                    : ""
                }
                setStartTime={startTime}
                setEndTime={endTime}
              />
            </Flex>

            <Grid
              mt={4}
              templateColumns="repeat(2, 1fr)"
              columnGap={6}    // <--- wider column space
              rowGap={4}         // <--- keep regular row spacing
            >
              {/* Case O เก่า */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Case O เก่า</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.old_o_case || 0}
                  onChange={(e) =>
                    handleCaseChange("old_o_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Case O ใหม่ */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Case O ใหม่</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.new_o_case || 0}
                  onChange={(e) =>
                    handleCaseChange("new_o_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Case R เก่า */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Case R เก่า</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.old_r_case || 0}
                  onChange={(e) =>
                    handleCaseChange("old_r_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Case R ใหม่ */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Case R ใหม่</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.new_r_case || 0}
                  onChange={(e) =>
                    handleCaseChange("new_r_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Lab */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Lab</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.lab_num || 0}
                  onChange={(e) =>
                    handleCaseChange("lab_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* X-Ray */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">X-Ray</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.xray_num || 0}
                  onChange={(e) =>
                    handleCaseChange("xray_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* EKG */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">EKG</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.ekg_num || 0}
                  onChange={(e) =>
                    handleCaseChange("ekg_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* CT */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">CT</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.ct_num || 0}
                  onChange={(e) =>
                    handleCaseChange("ct_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* PFT */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">PFT</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.pft_num || 0}
                  onChange={(e) =>
                    handleCaseChange("pft_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* ABI */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">ABI</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.abi_num || 0}
                  onChange={(e) =>
                    handleCaseChange("abi_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Obesity */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Obesity</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.obesity_num || 0}
                  onChange={(e) =>
                    handleCaseChange("obesity_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Treatment */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Treatment</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.treatment_num || 0}
                  onChange={(e) =>
                    handleCaseChange("treatment_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* ให้เลือด */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">ให้เลือด</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.blood_transfusion_num || 0}
                  onChange={(e) =>
                    handleCaseChange("blood_transfusion_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* Refer */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Refer</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.refer_num || 0}
                  onChange={(e) =>
                    handleCaseChange("refer_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Chemo */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Chemo</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.chemo_num || 0}
                  onChange={(e) =>
                    handleCaseChange("chemo_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* OR */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">OR</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.or_num || 0}
                  onChange={(e) =>
                    handleCaseChange("or_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* เจาะเลือด / Blood letting */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Blood letting</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.blood_letting_num || 0}
                  onChange={(e) =>
                    handleCaseChange("blood_letting_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* เจาะปอด */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">เจาะปอด</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.lung_tap_num || 0}
                  onChange={(e) =>
                    handleCaseChange("lung_tap_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* เจาะไขกระดูก */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">เจาะไขกระดูก</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.bone_marrow_tap_num || 0}
                  onChange={(e) =>
                    handleCaseChange("bone_marrow_tap_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* Vaccine Flu */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Vaccine Flu</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_flu_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_flu_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Vaccine IPD */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Vaccine IPD</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_ipd_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_ipd_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Vaccine Dengue */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Vaccine Dengue</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_dengue_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_dengue_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Vaccine Zoster */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Vaccine Zoster</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_zoster_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_zoster_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Vaccine RSV */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Vaccine RSV</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_rsv_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_rsv_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </Flex>

              {/* Case O Admit */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Case O Admit</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.admit_o_case || 0}
                  onChange={(e) =>
                    handleCaseChange("admit_o_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Case R Admit */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Case R Admit</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.admit_r_case || 0}
                  onChange={(e) =>
                    handleCaseChange("admit_r_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              {/* Check up */}
              <Flex align="center" gap={2}>
                <FormLabel fontSize={"small"} m={0} minW="75px">Check up</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.check_up || 0}
                  onChange={(e) =>
                    handleCaseChange("check_up", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </Flex>

              <Box>{/* dummy */}</Box>

              {/* งดออกตรวจ */}
              <Checkbox
                mt={5}
                my={5}
                isChecked={record?.is_skipted || 0}
                onChange={() => {
                  const isSkipted = record?.is_skipted ? 0 : 1;
                  handleCaseChange("is_skipted", isSkipted)

                  if (isSkipted) {
                    handleCaseChange("old_o_case", 0)
                    handleCaseChange("new_o_case", 0)
                    handleCaseChange("old_r_case", 0)
                    handleCaseChange("new_r_case", 0)
                    handleCaseChange("lab_num", 0)
                    handleCaseChange("xray_num", 0)
                    handleCaseChange("ekg_num", 0)
                    handleCaseChange("abi_num", 0)
                    handleCaseChange("obesity_num", 0)
                    handleCaseChange("treatment_num", 0)
                    handleCaseChange("refer_num", 0)
                    handleCaseChange("vacc_flu_num", 0)
                    handleCaseChange("vacc_ipd_num", 0)
                    handleCaseChange("vacc_dengue_num", 0)
                    handleCaseChange("vacc_zoster_num", 0)
                    handleCaseChange("admit_o_case", 0)
                    handleCaseChange("admit_r_case", 0)
                    handleCaseChange("check_up", 0)

                    handleCaseChange("vacc_rsv_num", 0);
                    handleCaseChange("ct_num", 0);
                    handleCaseChange("pft_num", 0);
                    handleCaseChange("blood_transfusion_num", 0);
                    handleCaseChange("or_num", 0);
                    handleCaseChange("chemo_num", 0);
                    handleCaseChange("blood_letting_num", 0);
                    handleCaseChange("lung_tap_num", 0);
                    handleCaseChange("bone_marrow_tap_num", 0);

                    // Reset the additional period as well
                    handleCaseChange("has_additional_period", 0);
                    handleCaseChange("additional_start_diag_time", "");
                    handleCaseChange("additional_end_diag_time", "");
                    setAditionalStartTime("");
                    setAditionalEndTime("");
                  }
                }}
              >
                งดออกตรวจ
              </Checkbox>

              {/* ออกตรวจชดเชย */}
              <Checkbox
                mt={5}
                my={5}
                isDisabled={record?.is_skipted}
                isChecked={record?.has_additional_period || 0}
                onChange={() => {
                  const hasAdditionalPeriod = record?.has_additional_period ? 0 : 1;
                  handleCaseChange("has_additional_period", hasAdditionalPeriod)

                  if (hasAdditionalPeriod == 0) {
                    handleCaseChange("additional_start_diag_time", "")
                    handleCaseChange("additional_end_diag_time", "")
                    setAditionalStartTime("")
                    setAditionalEndTime("")
                  }
                }}
              >
                ออกตรวจชดเชย
              </Checkbox>
            </Grid>

            {/*
            <Grid mt={4} templateColumns="repeat(2, 1fr)" gap={4}>
              <FormControl>
                <FormLabel>Case O เก่า</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.old_o_case || 0}
                  onChange={(e) =>
                    handleCaseChange("old_o_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Case O ใหม่</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.new_o_case || 0}
                  onChange={(e) =>
                    handleCaseChange("new_o_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Case R เก่า</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.old_r_case || 0}
                  onChange={(e) =>
                    handleCaseChange("old_r_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Case R ใหม่</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.new_r_case || 0}
                  onChange={(e) =>
                    handleCaseChange("new_r_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Lab</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.lab_num || 0}
                  onChange={(e) =>
                    handleCaseChange("lab_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>X-Ray</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.xray_num || 0}
                  onChange={(e) =>
                    handleCaseChange("xray_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>EKG</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.ekg_num || 0}
                  onChange={(e) =>
                    handleCaseChange("ekg_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>CT</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.ct_num || 0}
                  onChange={(e) =>
                    handleCaseChange("ct_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>PFT</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.pft_num || 0}
                  onChange={(e) =>
                    handleCaseChange("pft_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>ABI</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.abi_num || 0}
                  onChange={(e) =>
                    handleCaseChange("abi_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Obesity</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.obesity_num || 0}
                  onChange={(e) =>
                    handleCaseChange("obesity_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Treatment</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.treatment_num || 0}
                  onChange={(e) =>
                    handleCaseChange("treatment_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>ให้เลือด</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.blood_transfusion_num || 0}
                  onChange={(e) =>
                    handleCaseChange("blood_transfusion_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Refer</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.refer_num || 0}
                  onChange={(e) =>
                    handleCaseChange("refer_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Chemo</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.chemo_num || 0}
                  onChange={(e) =>
                    handleCaseChange("chemo_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>OR</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.or_num || 0}
                  onChange={(e) =>
                    handleCaseChange("or_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>เจาะเลือด</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.blood_letting_num || 0}
                  onChange={(e) =>
                    handleCaseChange("blood_letting_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>เจาะปอด</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.lung_tap_num || 0}
                  onChange={(e) =>
                    handleCaseChange("lung_tap_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>เจาะไขกระดูก</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.bone_marrow_tap_num || 0}
                  onChange={(e) =>
                    handleCaseChange("bone_marrow_tap_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Vaccine Flu</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_flu_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_flu_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>Vaccine IPD</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_ipd_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_ipd_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Vaccine Dengue</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_dengue_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_dengue_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Vaccine Zoster</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_zoster_num || 0}
                  onChange={(e) =>
                    handleCaseChange(
                      "vacc_zoster_num",
                      parseInt(e.target.value)
                    )
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Vaccine RSV</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.vacc_rsv_num || 0}
                  onChange={(e) =>
                    handleCaseChange("vacc_rsv_num", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>{num}</option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Case O Admit</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.admit_o_case || 0}
                  onChange={(e) =>
                    handleCaseChange("admit_o_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Case R Admit</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.admit_r_case || 0}
                  onChange={(e) =>
                    handleCaseChange("admit_r_case", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <FormLabel>Check up</FormLabel>
                <Select
                  bgColor="white"
                  value={record?.check_up || 0}
                  onChange={(e) =>
                    handleCaseChange("check_up", parseInt(e.target.value))
                  }
                >
                  {numbers.map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <Checkbox
                isChecked={record?.is_skipted || 0}
                onChange={() => {
                  const isSkipted = record?.is_skipted ? 0 : 1;
                  handleCaseChange("is_skipted", isSkipted)

                  if (isSkipted) {
                    handleCaseChange("old_o_case", 0)
                    handleCaseChange("new_o_case", 0)
                    handleCaseChange("old_r_case", 0)
                    handleCaseChange("new_r_case", 0)
                    handleCaseChange("lab_num", 0)
                    handleCaseChange("xray_num", 0)
                    handleCaseChange("ekg_num", 0)
                    handleCaseChange("abi_num", 0)
                    handleCaseChange("obesity_num", 0)
                    handleCaseChange("treatment_num", 0)
                    handleCaseChange("refer_num", 0)
                    handleCaseChange("vacc_flu_num", 0)
                    handleCaseChange("vacc_ipd_num", 0)
                    handleCaseChange("vacc_dengue_num", 0)
                    handleCaseChange("vacc_zoster_num", 0)
                    handleCaseChange("admit_o_case", 0)
                    handleCaseChange("admit_r_case", 0)
                    handleCaseChange("check_up", 0)

                    handleCaseChange("vacc_rsv_num", 0);
                    handleCaseChange("ct_num", 0);
                    handleCaseChange("pft_num", 0);
                    handleCaseChange("blood_transfusion_num", 0);
                    handleCaseChange("or_num", 0);
                    handleCaseChange("chemo_num", 0);
                    handleCaseChange("blood_letting_num", 0);
                    handleCaseChange("lung_tap_num", 0);
                    handleCaseChange("bone_marrow_tap_num", 0);

                    // Reset the additional period as well
                    handleCaseChange("has_additional_period", 0);
                    handleCaseChange("additional_start_diag_time", "");
                    handleCaseChange("additional_end_diag_time", "");
                    setAditionalStartTime("");
                    setAditionalEndTime("");
                  }
                }
                }
              >
                งดออกตรวจ
              </Checkbox>

              <Checkbox
                isDisabled={record?.is_skipted}
                isChecked={record?.has_additional_period || 0}
                onChange={() => {
                  const hasAdditionalPeriod = record?.has_additional_period ? 0 : 1;
                  handleCaseChange("has_additional_period", hasAdditionalPeriod)

                  if (hasAdditionalPeriod == 0) {
                    handleCaseChange("additional_start_diag_time", "")
                    handleCaseChange("additional_end_diag_time", "")
                    setAditionalStartTime("")
                    setAditionalEndTime("")
                  }
                }
                }
              >
                ออกตรวจชดเชย
              </Checkbox>
            </Grid>
            */}

            {record?.has_additional_period ? <Flex py={2} my={2} bgColor={"blue.50"} direction={"column"} justify={"center"} align={"center"}>
              {(aditionalStartTime && aditionalEndTime) ? (
                <Text mb={3}>เวลาออกชดเชย ({`${aditionalStartTime} - ${aditionalEndTime}`})</Text>
              ) : (
                <Text>กรุณาระบุเวลาออกชดเชย</Text>
              )}
              <TimeRangeWidget
                resetTime={record?.is_skipted}
                sHour={
                  record && record.additional_start_diag_time
                    ? `${moment(record?.additional_start_diag_time, "HH:mm").format("HH")}`
                    : ""
                }
                sMinute={
                  record && record.additional_start_diag_time
                    ? `${moment(record?.additional_start_diag_time, "HH:mm").format("mm")}`
                    : ""
                }
                eHour={
                  record && record.additional_end_diag_time
                    ? `${moment(record?.additional_end_diag_time, "HH:mm").format("HH")}`
                    : ""
                }
                eMinute={
                  record && record.additional_end_diag_time
                    ? `${moment(record?.additional_end_diag_time, "HH:mm").format("mm")}`
                    : ""
                }
                setStartTime={handleAdditionStartTime}
                setEndTime={handleAdditionEndTime}
              />
            </Flex> : <></>}

          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSaveRecord}>
              บันทึก
            </Button>
            <Button variant="outline" onClick={onClose}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PatientRecordModal;
